import React, { useCallback } from "react";
import { PhoneNumberInput } from "../../../../Forms/Inputs/PhoneNumberInput/React";
import InputWrapperWithHeading from "../shared/inputWrapperWithHeading";

interface PhoneNumberFieldProps {
  id: string;
  name?: string;
  label?: string;
  description?: string;
  errorMessage?: string;
  placeholder?: string;
  searchPlaceholder?: string;
  countryCodeAriaLabel?: string;
  value?: string;
  language?: string;
  required?: boolean;
  isValid: boolean;
  hasBlurred: boolean;
  formValidated: boolean;
  onValueChange: (value: string) => void;
  onBlur?: () => void;
}

/**
 * PhoneNumberField is a specialized form field for phone number input
 * with country code selection.
 */
export const PhoneNumberField = React.memo(function PhoneNumberField({
  id,
  name,
  label,
  description,
  errorMessage,
  placeholder,
  searchPlaceholder,
  countryCodeAriaLabel,
  value,
  language,
  required = false,
  isValid,
  hasBlurred,
  formValidated,
  onValueChange,
  onBlur
}: PhoneNumberFieldProps) {
  const handleValueChanged = useCallback(
    (newValue: string) => {
      onValueChange(newValue);
    },
    [onValueChange]
  );

  const handleBlur = useCallback(() => {
    if (onBlur) {
      onBlur();
    }
  }, [onBlur]);

  const showError = !isValid && (formValidated || hasBlurred);

  return (
    <InputWrapperWithHeading
      id={id}
      label={label}
      description={description}
      errorMessage={errorMessage}
      required={required}
      invalid={showError}
    >
      <PhoneNumberInput
        id={id}
        name={name}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        countryCodeAriaLabel={countryCodeAriaLabel}
        value={value}
        language={language}
        onValueChanged={handleValueChanged}
        onBlur={handleBlur}
        invalid={showError}
      />
    </InputWrapperWithHeading>
  );
});

export default PhoneNumberField;
